import React from 'react';
import { ABOUT, REGION_LEADERSHIP } from '../mock';
import { Star, BookOpen, Flag, Users2 } from 'lucide-react';

export default function About() {
  return (
    <div className="fade-in-up">
      <section className="banner-bg section-noise">
        <div className="max-w-5xl mx-auto px-4 py-16 text-center">
          <div className="chip mb-3">ABOUT</div>
          <h1 className="font-display text-5xl md:text-6xl gold-text-fill mb-3">CBTU REGION III</h1>
          <p className="font-serif-script text-xl text-cbtu-cream">Founded 1972 · Chicago, IL</p>
          <div className="gold-divider my-6"></div>
          <p className="text-lg text-cbtu-text/90 leading-relaxed">{ABOUT.mission}</p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-2 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Flag className="text-gold" size={22} />
            <h2 className="font-display text-3xl text-cbtu-cream">OUR OBJECTIVES</h2>
          </div>
          <ul className="space-y-3">
            {ABOUT.objectives.map((o) => (
              <li key={o} className="flex items-start gap-3 text-cbtu-text/90">
                <Star size={16} className="text-gold mt-1 flex-shrink-0" fill="currentColor" />
                <span>{o}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="flex items-center gap-2 mb-4">
            <BookOpen className="text-gold" size={22} />
            <h2 className="font-display text-3xl text-cbtu-cream">FOUNDERS</h2>
          </div>
          <p className="text-cbtu-text/85 mb-4">CBTU was founded in 1972 by a determined group of Black trade unionists who answered A. Philip Randolph’s call for an organized voice within the labor movement.</p>
          <ul className="space-y-2 text-cbtu-cream">
            {ABOUT.founders.map((f) => (
              <li key={f} className="border-l-2 border-gold pl-4 py-1 font-heading tracking-wide">{f}</li>
            ))}
          </ul>
        </div>
      </section>

      <section className="bg-cbtu-navy/60 border-y border-gold/20">
        <div className="max-w-6xl mx-auto px-4 py-16">
          <div className="flex items-center gap-2 mb-6">
            <Users2 className="text-gold" size={22} />
            <h2 className="font-display text-3xl text-cbtu-cream">REGION III LEADERSHIP</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {REGION_LEADERSHIP.map((p) => (
              <div key={p.name} className="card-dark p-5 rounded-md">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-cbtu-gold to-amber-700 flex items-center justify-center text-cbtu-black font-display text-lg mb-3">
                  {p.name.split(' ').filter(w => w[0] === w[0].toUpperCase()).slice(0,2).map(w => w[0]).join('')}
                </div>
                <div className="font-heading text-lg text-cbtu-cream">{p.name}</div>
                <div className="text-gold text-sm tracking-wide">{p.role}</div>
                <div className="text-xs text-cbtu-muted mt-1">{p.union} · {p.city}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 py-16">
        <blockquote className="text-center">
          <p className="font-serif-script text-2xl md:text-3xl text-cbtu-cream leading-relaxed">
            “At the banquet table of nature, there are no reserved seats. You get what you can take, and you keep what you can hold. And you can’t take anything without organization.”
          </p>
          <footer className="mt-4 font-heading tracking-widest text-gold text-sm">— A. PHILIP RANDOLPH</footer>
        </blockquote>
      </section>
    </div>
  );
}
